import React from "react";
import { useTranslation } from "react-i18next";
import analyticsService from "../../services/analyticsService";
import { buildSupportWhatsAppUrl } from "../../constants/support";
import SupportCallLink from "../ui/SupportCallLink";
import ScreenLayout from "../ui/ScreenLayout";
import Button from "../ui/Button";
import Icon from "../ui/Icon";

// Écran 1h : la préautorisation est passée mais la recharge ne démarre pas.
export default function ChargeStartFailedScreen({ station, connector, failureReason, onRetry, panel }) {
  const { t } = useTranslation();
  const analyticsParams = { station_id: station, connector_id: connector, error_type: failureReason };

  const footer = (
    <>
      <Button
        variant="whatsapp"
        icon="whatsapp"
        href={buildSupportWhatsAppUrl(t, { station, connector })}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => analyticsService.pushEvent("support_whatsapp_clicked", analyticsParams)}
      >
        {t("support.whatsapp")}
      </Button>
      <Button variant="secondary" onClick={onRetry}>
        {t("startCharging.startFailed.retry")}
      </Button>
      <SupportCallLink analyticsParams={analyticsParams} />
    </>
  );

  return (
    <ScreenLayout footer={footer} panel={panel}>
      <div className="pt-6 md:pt-0" aria-live="assertive">
        <div className="h-16 w-16 rounded-full bg-qv-amber-50 flex items-center justify-center">
          <Icon name="danger-triangle-bold" size={32} className="text-qv-amber" />
        </div>
        <h1 className="mt-5 mb-2 text-[26px] leading-[34px] tracking-[-.02em] font-bold md:text-[30px] md:leading-[38px]">
          {t("startCharging.startFailed.title")}
        </h1>
        <p className="mb-5 text-[15px] leading-6 text-qv-muted">{t("startCharging.startFailed.subtitle")}</p>

        <div className="mb-5 rounded-2xl bg-qv-green-50 p-4 flex gap-3 items-start">
          <Icon name="shield-check-bold" size={22} className="text-qv-green" />
          <p className="text-sm leading-5 font-medium">
            <b>{t("startCharging.startFailed.noCharge")}</b> {t("startCharging.startFailed.preauthRelease")}
          </p>
        </div>

        <p className="mb-2.5 text-xs font-semibold tracking-[.08em] uppercase text-qv-muted">
          {t("startCharging.startFailed.checklistTitle")}
        </p>
        <ul className="flex flex-col gap-2.5 text-sm leading-5 font-medium">
          <li className="flex gap-2.5">
            <Icon name="plug-circle-linear" size={20} className="text-qv-brand" />
            {t("startCharging.startFailed.checkCable")}
          </li>
          <li className="flex gap-2.5">
            <Icon name="car-linear" size={20} className="text-qv-brand" />
            {t("startCharging.startFailed.checkSchedule")}
          </li>
        </ul>
      </div>
    </ScreenLayout>
  );
}
